import { ImageResponse } from "./ImageResponse";
import { TownHall } from "./TownHall";
import { Province } from "./Province";
import { District } from "./District";
import { Municipality } from "./Municipality";

export class Farm {
    public id?: number;
    public geometry?: any;
    public information: string;
    public accessRoad: boolean;
    public area: number;
    public fileRoots?: ImageResponse [];
    public available: boolean;
    public objectives: [];
    public exploitations: [];
    public townHallDTO: TownHall;
    public provinceDTO: Province;
    public townHall: string;
    public province: string;
    public district?: string;
    public municipality?: string;
    public districtDTO?: District;
    public municipalityDTO?: Municipality;

}
